import { authAxios } from "./axiosClient";
import {
  quizURL,
  questiontypeURL,
  documentISMSURL,
} from "../constants";

export const GetQuizApi = (params = {}) => {
  return authAxios().get(quizURL, { params });
};

export const GetTypeQuestionApi = (params = {}) => {
  return authAxios().get(questiontypeURL, { params });
};

export const PostTypeQuestionApi = (params = {}) => {
  const url = questiontypeURL;
  return authAxios().post(url, params);
};

export const PostQuizApi = (params = {}) => {
  const url = quizURL;
  return authAxios().post(url, params);
};

export const PostDocumentApi = (params = {}) => {
  const url = documentISMSURL;
  return authAxios().post(url, params);
};

export const DelDocumentApi = (params = {}) => {
  const url = documentISMSURL;
  return authAxios().delete(url, { params });
};

export const PutTypeQuestionApi = (params = {}) => {
  const url = questiontypeURL;
  return authAxios().put(url, params);
};

export const DelTypeQuestionApi = (params = {}) => {
  const url = questiontypeURL;
  return authAxios().delete(url, { params });
};
